import Client from '../HttpClient';

const baseUrl = '/gateway/eagle-mgt/api/vs/reservation-report';

const statistics = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/statistics`, data);
};

const weeklyPerformance = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/weekly-performance`, data);
};

const timeMatrix = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/time-matrix`, data);
};

const availabilityCalendar = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/availability-calendar`, data);
};

const workload = (merchantId, data) => {
	return Client.get(`${baseUrl}/${merchantId}/reservations/workload`, data);
};

const guestList = (merchantId, branchId, data) => {
	return Client.get(
		`${baseUrl}/${merchantId}/${branchId}/reservations/guest-summary`,
		data
	);
};

export default {
	statistics,
	weeklyPerformance,
	timeMatrix,
	availabilityCalendar,
	workload,
	guestList,
};
